import getDefaultState from '../helpers/StateHelper';

export default {
  initState(state) {
    Object.assign(state, getDefaultState);
  },
};
